<template>
    <div class="grid-container px-1 pb-1 fill-height">
        <v-card @click="1" class="text-center align-center d-flex"  style="grid-area:dot">
            <v-card-text style="font-weight: bolder;" class="pa-0 mx-auto" @click="topic='';payload={};submitCommand();">.</v-card-text>
        </v-card>
        <v-card @click="1" class="text-center align-center d-flex"  style="grid-area:enter">
            <v-card-text style="font-weight: bolder;" class="pa-0 mx-auto" @click="topic='';payload={};submitCommand();">Enter</v-card-text>
        </v-card>
        <v-card @click="1" class="text-center align-center d-flex"  style="grid-area:zero">
            <v-card-text style="font-weight: bolder;" class="pa-0 mx-auto" @click="topic='';payload={};submitCommand();">mic on/off</v-card-text>
        </v-card>
        <v-card @click="1" class="text-center align-center d-flex"  style="grid-area:one">
            <v-card-text style="font-weight: bolder;" class="pa-0 mx-auto" @click="topic='mote://window';payload={'operate':'change','workspace':'1'};submitCommand();">w1</v-card-text>
        </v-card>
        <v-card @click="1" class="text-center align-center d-flex"  style="grid-area:two">
            <v-card-text style="font-weight: bolder;" class="pa-0 mx-auto" @click="topic='mote://window';payload={'operate':'change','workspace':'2'};submitCommand();">w2</v-card-text>
        </v-card>
        <v-card @click="1" class="text-center align-center d-flex"  style="grid-area:three">
            <v-card-text style="font-weight: bolder;" class="pa-0 mx-auto" @click="topic='mote://window';payload={'operate':'change','workspace':'3'};submitCommand();">w3</v-card-text>
        </v-card>
        <v-card @click="1" class="text-center align-center d-flex"  style="grid-area:four">
            <v-card-text style="font-weight: bolder;" class="pa-0 mx-auto" @click="topic='mote://window';payload={'operate':'change','workspace':'4'};submitCommand();">w4</v-card-text>
        </v-card>
        <v-card @click="1" class="text-center align-center d-flex"  style="grid-area:five">
            <v-card-text style="font-weight: bolder;" class="pa-0 mx-auto" @click="topic='';payload={};submitCommand();">super</v-card-text>
        </v-card>
        <v-card @click="1" class="text-center align-center d-flex"  style="grid-area:six">
            <v-card-text style="font-weight: bolder;" class="pa-0 mx-auto" @click="topic='mote://window';payload={'operate':'change','workspace':'0'};submitCommand();">w0</v-card-text>
        </v-card>
        <v-card @click="1" class="text-center align-center d-flex"  style="grid-area:seven">
            <v-card-text style="font-weight: bolder;" class="pa-0 mx-auto" @click="topic='';payload={};submitCommand();">shot</v-card-text>
        </v-card>
        <v-card @click="1" class="text-center align-center d-flex"  style="grid-area:eight">
            <v-card-text style="font-weight: bolder;" class="pa-0 mx-auto" @click="topic='';payload={};submitCommand();">win</v-card-text>
        </v-card>
        <v-card @click="1" class="text-center align-center d-flex"  style="grid-area:nine">
            <v-card-text style="font-weight: bolder;" class="pa-0 mx-auto" @click="topic='';payload={};submitCommand();">cast</v-card-text>
        </v-card>
        <v-card @click="1" class="text-center align-center d-flex"  style="grid-area:plus">
            <v-card-text style="font-weight: bolder;" class="pa-0 mx-auto" @click="topic='';payload={};submitCommand();">vol+</v-card-text>
        </v-card>
        <v-card @click="1" class="text-center align-center d-flex"  style="grid-area:minus">
            <v-card-text style="font-weight: bolder;" class="pa-0 mx-auto" @click="topic='';payload={};submitCommand();">vol-</v-card-text>
        </v-card>
        <v-card @click="1" class="text-center align-center d-flex"  style="grid-area:multiply">
            <v-card-text style="font-weight: bolder;" class="pa-0 mx-auto" @click="topic='';payload={};submitCommand();">mute</v-card-text>
        </v-card>
        <v-card @click="1" class="text-center align-center d-flex"  style="grid-area:divide">
            <v-card-text style="font-weight: bolder;" class="pa-0 mx-auto" @click="topic='';payload={};submitCommand();">switch</v-card-text>
        </v-card>
        <v-card @click="1" class="text-center align-center d-flex"  style="grid-area:bs">
            <v-card-text style="font-weight: bolder;" class="pa-0 mx-auto" @click="topic='';payload={};submitCommand();">Back<br/>Space</v-card-text>
        </v-card>
        <v-card @click="1" class="text-center align-center d-flex"  style="grid-area:numlock">
            <v-card-text style="font-weight: bolder;" class="pa-0 mx-auto" @click="topic='';payload={};submitCommand();">Num<br/>Lock</v-card-text>
        </v-card>
    </div>
</template>
<style lang="scss" scoped>
    .v-card--link:before{
        background:inherit !important;
    }
    .grid-container{
        display:grid;
        justify-content: center;
        grid-template-columns:  minmax(3rem,100px) minmax(3rem,100px) minmax(3rem,100px) minmax(3rem,100px);
        grid-template-rows: minmax(3rem,100px) minmax(3rem,100px) minmax(3rem,100px) minmax(3rem,100px) minmax(3rem,100px);
        grid-template-areas: 
          "numlock divide multiply minus"
          "seven eight nine plus"
          "four five six bs"
          "one two three enter"
          "zero zero dot enter";
        column-gap: 10px;
        row-gap: 10px;
        }
        

</style>
<script>
export default {
    name:'PMKeybot',
    data(){
        return {
            topic:'',
            payload:'',
            audio:null,
        }
    },
    props:['mms','mmsReady','moteDDN'],
    watch:{
        mmsReady:{
            handler(val){
                if(val){
                    this.topic="mote://audio";
                    this.payload={'operate':'list'};
                    this.submitCommand();
                }
            },
            immediate: true
        }
    },
    methods:{
        async submitCommand(){
            let res;
            try {
                res = await this.mms.sendMMS({
                   DDN : this.moteDDN,
                   topic : this.topic,
                   payload: this.isJson(this.payload) ? JSON.parse(this.payload) : this.payload
               });
            } catch (error) {
            }
             if(res){
                 let result;
                 if(typeof res == 'object')
                     result = res;
                 else
                     result = res[0];
                 console.log(result);
                 if(!result)
                   return;
            }
        }
    }
}
</script>